import React from 'react'

import BiddingContractSubstep from './BiddingContractSubstep'
import GanttChartPositions from '../projects/GanttChartPositions'
import ProjectPosition from "../../models/ProjectPosition";
import LoadingSpinner from "../../components/LoadingSpinner";
import Project from "../../models/Project";


export default class BiddingContractScheduleSubstep extends BiddingContractSubstep
{
    // static SubstepName = 'Review Team & Schedule';
    static SubstepName = 'start_project.contract_schedule.title';

	static TranslationKey = 'start_project.contract_schedule';

	static SubstepSlug = 'schedule';
	static path = '/schedule';


    static StepTitle = 'Review Team Schedule';
    static StepInfo = '';

    static getStepName(project) {
        return (project.acceptsStandardSOW() && project.isBYO()) ? 'Approve Team Schedule' : this.SubstepName;
    }

	constructor(props)
	{
		super(props);

		this.state = {
			...this.state,
		};
	}

    async onUpdatePosition(position) {
        if (this.state.isLoading) {
            return false;
        }
	    await this.promisedState({
            isLoading: true
        });

        let positions = [...this.props.project.sortedPositions()];

        let positionIndex = TB.findIndex(positions, ['id', position.id]);


        positions[positionIndex] = ProjectPosition.make({
            ...position
        });

        let response = await this.props.makeRequest(
            () => this.props.project.update({positions}),
            Project.SyncRequest
        );

        await this.promisedState({isLoading: false});


        if (response) {
            await TB.toast("Project Position Updated!", {theme: 'success'})
            //TB.sysAlert('sow_approval.edited_talent_schedule')
        }else {
            await TB.showServerErrorToast();
        }
        return true;
    }

	async onDeletePosition(position) {
        if (this.state.isLoading) {
            return false;
        }
        let shouldDelete = await TB.sysAlert('sow_approval.delete_role_confirmation');

        if (!shouldDelete) {
            return;
        }

        await this.promisedState({isLoading: true});

        let response = await this.props.makeRequest(
            () => this.props.project.deletePosition(position),
            Project.SyncRequest
        );

        await this.promisedState({isLoading: false});
    }

	renderStepInfo() {
        if (!this.props.project?.acceptsStandardSOW() || !this.props.project.isBYO()) {
            return null
        }

        const { canEditSOWForProject, isLocked } = this.props;
        return (
            <React.Fragment>
                <p>
                    Review each team member's start and end date for your project below (dates were pulled from the project brief).
                </p>
                {!isLocked && (
                    <React.Fragment>
                        {/*<p>*/}
                        {/*    <b>*/}
                        {/*        <i>*/}

                        {/*            You can make changes to these dates below, however talent has already accepted the dates and*/}
                        {/*            significant changes may impact the availability of the specific team member for this*/}
                        {/*            project. You can move up the start date by up to <span className="text-danger">14 days</span>. The end date will adjust accordingly.*/}
                        {/*        </i>*/}
                        {/*    </b>*/}
                        {/*</p>*/}
                        <p>
                            Below you can remove position that are no longer needed for the project.
                        </p>
                    </React.Fragment>
                )}

                {this.props.project.acceptsStandardSOW() && this.props.project.isBYO() && (
                    <div className="mt-2">
                        <button
                            type="button"
                            onClick={() => {
                                if (!canEditSOWForProject) {
                                    return TB.showPermissionError();
                                }
                                this.props.approveStep();
                            }}
                            className={TB.mapClass('btn btn-primary approve-btn', { 'disabled-edit-link': !canEditSOWForProject })}
                            disabled={this.props.isDisabled || this.props.isLocked}
                        >
                            Approve & Continue
                            {!canEditSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                        </button>
                    </div>
                )}
            </React.Fragment>
        );
    }

    renderStepContent()
	{
		let { project, canEditSOWForProject, forReview, isLocked } = this.props;
		if (!project || !project.anticipatedStart() || !project.anticipatedEnd()) {
			return <div/>
		}

		let {isLoading} = this.state;

		return (
			<div className="sow-approval-step sow-approval-schedule">

                {/*<div className="timerange-header">*/}
                {/*    <div>*/}
                {/*        <p className="timerange-header-label">*/}
                {/*            Project Start Date*/}
                {/*        </p>*/}
                {/*        <p className="timerange-header-date">*/}
                {/*            {project.anticipatedStart().format('MMM D, YYYY')}*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*    <div>*/}
                {/*        <p className="timerange-header-label">*/}
                {/*            Project End Date*/}
                {/*        </p>*/}
                {/*        <p className="timerange-header-date">*/}
                {/*            {project.anticipatedEnd().format('MMM D, YYYY')}*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}


                <div className="gantt-chart-container">

                    {project.isBYO() &&
                        <GanttChartPositions
                            project={project} disabled={isLoading}
                            editable={project?.acceptsStandardSOW() && !forReview && !isLocked && canEditSOWForProject}
                            showCost={true}
                            onRemovePosition={(position) => this.onDeletePosition(position)}
                            onUpdatePosition={this.onUpdatePosition.bind(this)}
                        />
                    }

                    {isLoading && (
                        <div className="gantt-loader">
                            <LoadingSpinner size={'lg'}/>
                        </div>
                    )}
                </div>
			</div>
    	);
	}
}